import html2canvas from 'html2canvas';
import { isDevEnvironment } from 'utils/environment';
export interface ITakeOptions {
  element: HTMLElement;
  shouldIgnoreElement: (element: Element) => boolean;
}

export function take({ element, shouldIgnoreElement }: ITakeOptions): Promise<HTMLCanvasElement> {
  return html2canvas(element, {
    logging: isDevEnvironment(),
    ignoreElements: (htmlElement): boolean => {
      if (htmlElement instanceof HTMLImageElement && htmlElement.src.toLowerCase().includes('piwik')) {
        return true;
      }

      return shouldIgnoreElement(htmlElement);
    },
  });
}
